import React, { useState, useEffect } from "react";
import { useLocation, Navigate } from "react-router-dom";
import { connect } from "react-redux";
import ResumeBuilder from "./ResumeBuilder";
import TemplateSelector from "./TemplateSelector";
import { API_URL } from '../apiConfig';
import CSRFToken from '../cookies.js';
import docLoading from '../image/doc_loading.gif';


const Template = ({ isAuthenticated }) => {
  const location = useLocation();
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [resumeData, setResumeData] = useState();
  if(!location.state.resumeId)
    location.state.resumeId = location.state ? location.state.outputData.res_id : null;
  const resumeId = location.state ? location.state.resumeId : null;
  // const resume_Id = location.state ? location.state.outputData.res_id : null;
  const [isLoading,setIsLoading] = useState(true);


  // Check authentication status on component mount
  useEffect(() => {
    const fetchResumeData = async () => {
      const authToken = localStorage.getItem("access");
      if (!authToken) {
        return <Navigate to="/login" />;
      }
      if (resumeId) {
        try {
          const response = await fetch(`${API_URL}/user_check`, {
            method: 'POST',
            headers: {
              'X-CSRFToken': CSRFToken(document.cookie),
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify({ res_id: resumeId })
          });

          if (response.status === 200) {
            const data = await response.json();
            // setResumeData(data.output); // Ensure you are accessing the correct property
            setResumeData(location.state.outputData); // Ensure you are accessing the correct property
            setIsLoading(false);
          } else {
            console.error('Error:', response.statusText);
            setIsLoading(false);
          }
        } catch (error) {
          console.error('Error:', error);
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    fetchResumeData();
  }, []);

  //[resumeData, resumeId]

  // if (!resumeData) {
  //   return <div>Loading...</div>;
  // }


  return (
    <div>
      {!isLoading ? (
        <ResumeBuilder
          template={selectedTemplate}
          fetchDatas={{outputData:resumeData}}
        />
      ):(
        <div className="flex flex-wrap justify-center items-center h-[70vh]">
              <img src={docLoading} alt="Loading..." className="w-[150px] h-[150px]" />
        </div>
      )}
      
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.AuthReducer.isAuthenticated,
  };
};

export default connect(mapStateToProps)(Template);